module.exports = __webpack_public_path__ + "CrystalexGlassShop.jpg?2b81c5168c881bf9f731aa2e5c7fd75c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/CrystalexGlassShop.jpg
// module id = 244
// module chunks = 0